export * from './bewertet.interface';
